/** @jsxRuntime classic */
/** @jsx jsx */
import React, { useEffect, useState, useRef } from 'react'
import { jsx } from "@emotion/core";
import { ArrowLeft, CalendarIconWithoutNumber, Checkbox, Tick } from '../LandingHeader/Feedback/icons/Icons'
import { createTask } from '../action/common';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import AddTaskStatic from '../../pages/AddTasks/AddTaskStatic';
import { calendarFormat, convertUrlsToLinks, dateWithOverdueColor } from '../action/utilities';
import EditTaskList from '../../pages/AddTasks/EditTaskList';
import { setActiveTaskList, setActiveTasks, setTasks } from '../../redux/slices/AiTasks';
import TaskSourceIcon from '../../pages/Tasks/TaskSourceIcon';
import RecurringIcon from '../../pages/Tasks/RecurringIcon';
import ProjectTagIcon from '../../pages/Tasks/ProjectTagIcon';
import { saveTaskList } from '../action/chatGPT';
import { setTaskList } from '../../redux/slices/AiAssistant';
import TaskModal from '../../pages/Settings/Modal/TaskModal';

const TodoList = ({id, onCreateTodos = () => {}, defaultTasks = [], defaultOpen = false}) => {
    const [acceptedTasks, setAcceptedTasks] = useState([]);
    const [loading, setLoading] = useState(false);
    const {tasks, activeTaskList} = useSelector(state => state.aiTasks);
    const todoListBodyRef = useRef('');
    const [editTaskId, setEditTaskId] = useState(null);
    const dispatch = useDispatch();
    
    useEffect(() => {
        if(activeTaskList && tasks?.[activeTaskList]?.length > 0){
            if (todoListBodyRef.current) {
                todoListBodyRef.current.scrollTop = todoListBodyRef.current.scrollHeight;
            }
            document.getElementById('ai-assistant-fullscreen')?.classList?.add('slide-left');
        }
    }, [tasks, activeTaskList])

    const createTasks = async (e, onlySelected = false) => {
        e.preventDefault();
        e.stopPropagation();

        setLoading(true);
        let promises = [];
        const data = onlySelected ? acceptedTasks.map(taskIndex => ({...tasks?.[activeTaskList]?.[taskIndex], taskIndex})) : tasks?.[activeTaskList];
        data.forEach(async (task) => {
            const {title, description, dueDate, taskIndex} = task;
            const requestBody = {
                "title": title,
                "description": description,
                "tags": [],
                "project": null,
                "date": dueDate ? new Date(moment(dueDate, 'DD/MM/YYYY').startOf('date')).toISOString() : null,
                "repeat": null,
                "status": 0
            }
            promises.push(createTask(requestBody));
        })

        // wait for all promises to resolve
        const results = await Promise.allSettled(promises);
        promises = [];
        results.forEach((result, index) => {
            if(result?.status === 'fulfilled'){
                const {title} = result?.value?.data?.responseData?.data;
                const newTasksList = [...tasks[activeTaskList]].map(task => task.title === title ? result?.value?.data?.responseData?.data : task);
                //console.log('newTasksList', newTasksList);
                dispatch(setActiveTasks(newTasksList));
                dispatch(setTaskList({...tasks, [activeTaskList]: newTasksList}));
                promises.push(saveTaskList({tasks: newTasksList, activeTaskList, id}));
            }
        })
        await Promise.allSettled(promises);
        setAcceptedTasks([]);
        onCreateTodos();
        setLoading(false);
    }

    const editTaskHandler = (e, taskId) => {
        e.preventDefault();
        e.stopPropagation();
        
        setEditTaskId(taskId);
    }

    const updateHandler = (updatedValue) => {
        if(updatedValue !== null){
            const tasksList = [...tasks?.[activeTaskList]];   
            tasksList[updatedValue?.index] = {...updatedValue, updatedAt: new Date().toISOString(), Project: {title: updatedValue?.project}};
            dispatch(setTasks({tasks: tasksList, activeTaskList}));
            dispatch(setTaskList({...tasks, [activeTaskList]: tasksList}));
            saveTaskList({tasks: tasksList, activeTaskList, id});
            setEditTaskId(null);
        }
    }

    const hideTodoList = () => {
        dispatch(setActiveTaskList(null));
        document.getElementById('ai-assistant-fullscreen')?.classList?.remove('slide-left');
    }

    const onHideAddTaskStatic = (data = null) => {
        if(data?.createdAt){
            const tasksList = [...tasks?.[activeTaskList]];
            tasksList.push(data);
            dispatch(setActiveTasks(tasksList));
            dispatch(setTaskList({...tasks, [activeTaskList]: tasksList}));
            saveTaskList({tasks: tasksList, activeTaskList, id});
        }
    }

    return (
        tasks?.[activeTaskList]?.length > 0 || defaultOpen ? <div className='ai-todo-list gptContainer widgetWrapper quoteInner pb-5'>
            <div className='ctTitle'>
                <span className='cursor-pointer' onClick={hideTodoList}><ArrowLeft color={`var(--accent-color)`} opacity='1' /></span>
                <span className='darkPrimaryColor'>Your Tasks</span>
            </div>
            <div className='ai-todo-list-body' ref={todoListBodyRef}>
                <ul>
                {
                    [...defaultTasks, ...(tasks?.[activeTaskList] ?? [])]?.map((item, index) => {
                        const taskDate = item?.createdAt ? item.date : item?.dueDate ? moment(item?.dueDate, 'DD/MM/YYYY') : null;
                        return (
                            item?.title
                            ? 
                            (
                                editTaskId === index && !item?.createdAt
                                ?
                                <TaskModal
                                    show={true}
                                    editTaskData = {
                                        {
                                            item: {...item, index},
                                            setUpdatedValue: updateHandler,
                                            setEditTaskId: setEditTaskId
                                        }
                                    }
                                />
                                :
                                <li className='li-task-list' key={index}>
                                    <div className={`task-sections ${item?.createdAt ? 'dropDownBg' : ''}`}>
                                        {
                                            !item?.createdAt
                                            ?
                                            <Checkbox checked={acceptedTasks.includes(index)} onClick={e => e.stopPropagation()} onChange={() => acceptedTasks.includes(index) ? setAcceptedTasks(acceptedTasks => acceptedTasks.filter(taskIndex => taskIndex !== index)) : setAcceptedTasks(acceptedTasks => [...acceptedTasks, index])} />
                                            :
                                            <Tick color={`var(--accent-color)`} strokeWidth={2} />
                                        }
                                        <div css={{width: 'calc(100% - 80px)'}}>
                                            <div className='ai-todo-item task-formatting w-auto' css={{maxWidth: '90%'}} onClick={e => editTaskHandler(e, index)}>
                                                <span className='task-title' dangerouslySetInnerHTML={{__html: convertUrlsToLinks(item?.title)}} />
                                                <span className='task-description font text-secondary' dangerouslySetInnerHTML={{__html: convertUrlsToLinks(item?.description) ?? ''}} />
                                            </div>
                                            <div className="flex items-center justify-start gap-[10px] mt-[10px]">
                                                {
                                                    taskDate
                                                    &&
                                                    <span className="task-deta">
                                                        <CalendarIconWithoutNumber color={moment(taskDate).isBefore(moment(), 'day') ? 'var(--overDue-color)' : 'black'} width={12} height={13} />
                                                        <label className="ut-data" css={{color: "gray !important"}}>
                                                        { dateWithOverdueColor(moment(taskDate).startOf('day')) }
                                                        </label>
                                                    </span>
                                                }
                                                <TaskSourceIcon task={item} colorPicker={`var(--accent-color)`} />
                                                <RecurringIcon task={item} colorPicker={`var(--accent-color)`} />
                                                <ProjectTagIcon task={item} />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            ) 
                            : null
                        )
                    })
                }
                </ul>
            </div>
            <ul className='ai-todo-list-footer mt-5'>
                <li className="task-item li-task-list" css={{'&:hover': {background: 'none'}}}>
                    <AddTaskStatic onHide={onHideAddTaskStatic} />
                </li>
            </ul>
            {
                tasks?.[activeTaskList]?.length > 0
                &&
                <div className='ai-todo-list-footer flex items-center justify-start gap-5'  css={{
                    padding: '40px 30px !important',
                    'button:hover': {color: 'white', backgroundColor: `var(--accent-color)`}}}>
                    <button disabled={loading} onClick={createTasks} className='button button-primary task-action-button'>Accept All</button>
                    <button disabled={loading || acceptedTasks.length === 0} onClick={(e) => createTasks(e, true)} className='button button-primary task-action-button'>Accept Selected</button>
                    <button disabled={loading} onClick={() => setAcceptedTasks([])} className='button button-secondary task-action-button'>Cancel</button>
                </div>
            }
            
        </div> : null
    )
}

export default TodoList